import Design1 from './design-1';

import './index.css';


export default function ExternalAppBlock(props) {
    switch (props.settings?.design) {
        case 0 :
            return (<Design1 {...props} />);
        default:
            return (<Design1 {...props} />);
    }
};